<template>
  <section
    id="top"
    class="relative overflow-hidden px-4 pb-16 pt-28"
  >
    <div
      aria-hidden="true"
      class="pointer-events-none absolute left-1/2 top-0 h-[340px] w-[720px] -translate-x-1/2 rounded-full bg-cyan-400/16 blur-[140px]"
    ></div>
    <div
      aria-hidden="true"
      class="pointer-events-none absolute bottom-0 left-0 h-[420px] w-[420px] rounded-full bg-blue-500/[0.18] blur-[120px]"
    ></div>
    <div
      aria-hidden="true"
      class="pointer-events-none absolute right-0 top-24 h-[360px] w-[360px] rounded-full bg-white/[0.08] blur-[120px]"
    ></div>

    <div class="page-shell relative">
      <div class="grid min-h-[78vh] items-center gap-12 lg:grid-cols-[1.08fr_0.92fr]">
        <div class="max-w-2xl">
          <div class="inline-flex rounded-full border border-cyan-200/20 bg-white/[0.08] px-4 py-1.5 text-xs text-white/90">
            {{ t(companyName) }}
          </div>

          <h1 class="mt-8 text-5xl font-bold tracking-tight text-white sm:text-6xl md:text-7xl">
            {{ t(title) }}
          </h1>
          <p class="mt-4 text-2xl text-cyan-100/80 md:text-3xl">{{ t(subtitle) }}</p>

          <p class="mt-6 max-w-xl text-base leading-7 text-slate-200/70 md:text-lg">
            {{ t(description) }}
          </p>

          <div class="mt-10 flex flex-col gap-4 sm:flex-row">
            <button
              type="button"
            class="inline-flex items-center justify-center rounded-md bg-white px-6 py-2.5 text-sm font-medium text-[#06111f] transition-colors duration-200 hover:bg-cyan-50"
            @click="scrollToSection('products')"
          >
            {{ t(exploreButton) }}
          </button>
          <a
            href="mailto:beibei@beiyidata.cn"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center justify-center rounded-md border border-cyan-100/20 bg-cyan-300/10 px-6 py-2.5 text-sm text-white transition-colors duration-200 hover:bg-cyan-300/[0.18]"
          >
            {{ t(contactButton) }}
          </a>
        </div>

        <div class="mt-12 grid gap-4 sm:grid-cols-3">
          <div class="rounded-2xl border border-cyan-100/10 bg-white/[0.05] p-4">
            <p class="text-xs uppercase tracking-[0.24em] text-slate-300/60">{{ t(enterpriseLabel) }}</p>
            <p class="mt-2 text-lg font-semibold text-white">{{ t(enterpriseValue) }}</p>
          </div>
          <div class="rounded-2xl border border-cyan-100/10 bg-white/[0.05] p-4">
            <p class="text-xs uppercase tracking-[0.24em] text-slate-300/60">{{ t(dataProductsLabel) }}</p>
            <p class="mt-2 text-lg font-semibold text-white">{{ t(dataProductsValue) }}</p>
          </div>
          <div class="rounded-2xl border border-cyan-100/10 bg-white/[0.05] p-4">
            <p class="text-xs uppercase tracking-[0.24em] text-slate-300/60">{{ t(consumerLabel) }}</p>
            <p class="mt-2 text-lg font-semibold text-white">{{ t(consumerValue) }}</p>
          </div>
        </div>
      </div>

        <div class="space-y-5">
          <div class="rounded-[28px] border border-cyan-100/[0.12] bg-[linear-gradient(180deg,rgba(255,255,255,0.1),rgba(255,255,255,0.04))] p-5 shadow-[0_24px_80px_rgba(0,18,48,0.35)] backdrop-blur-xl">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-xs uppercase tracking-[0.24em] text-slate-300/60">{{ t(featuredLabel) }}</p>
                <p class="mt-2 text-2xl font-semibold text-white">PagePilot</p>
              </div>
              <span class="rounded-full border border-cyan-100/[0.12] bg-cyan-300/10 px-3 py-1 text-xs text-cyan-50">
                {{ t(costLabel) }}
              </span>
            </div>

            <div class="mt-5 overflow-hidden rounded-2xl border border-white/10 bg-[#071a30]">
              <div class="flex items-center gap-2 border-b border-white/[0.08] px-4 py-3">
                <span class="h-2.5 w-2.5 rounded-full bg-rose-400"></span>
                <span class="h-2.5 w-2.5 rounded-full bg-amber-300"></span>
                <span class="h-2.5 w-2.5 rounded-full bg-emerald-400"></span>
                <span class="ml-3 text-xs text-slate-300/65">pagepilot://summarize/current-page</span>
              </div>
              <div class="grid gap-4 p-4 md:grid-cols-[1.1fr_0.9fr]">
                <div class="rounded-xl border border-white/[0.08] bg-white/[0.04] p-4">
                  <p class="text-sm font-medium text-white">{{ t(pageAssistantLabel) }}</p>
                  <div class="mt-4 space-y-3">
                    <div class="h-2 rounded-full bg-cyan-100/15"></div>
                    <div class="h-2 w-5/6 rounded-full bg-cyan-100/15"></div>
                    <div class="h-2 w-4/6 rounded-full bg-cyan-100/15"></div>
                  </div>
                </div>
                <div class="space-y-3">
                  <div class="rounded-xl border border-cyan-300/[0.12] bg-cyan-300/10 px-4 py-3 text-sm text-cyan-50">
                    {{ t(askPageLabel) }}
                  </div>
                  <div class="rounded-xl border border-white/[0.08] bg-white/[0.04] px-4 py-3 text-sm text-white/90">
                    {{ t(translateLabel) }}
                  </div>
                  <div class="rounded-xl border border-white/[0.08] bg-white/[0.04] px-4 py-3 text-sm text-white/90">
                    {{ t(summaryLabel) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="grid gap-5 md:grid-cols-2">
            <div class="rounded-3xl border border-white/10 bg-white/[0.05] p-5 backdrop-blur-xl">
              <p class="text-xs uppercase tracking-[0.24em] text-slate-300/60">{{ t(dataPlatformLabel) }}</p>
              <div class="mt-4 flex flex-wrap gap-2">
                <span class="rounded-full border border-white/10 bg-white/[0.06] px-3 py-1.5 text-xs text-white">{{ t(dataTag1) }}</span>
                <span class="rounded-full border border-white/10 bg-white/[0.06] px-3 py-1.5 text-xs text-white">{{ t(dataTag2) }}</span>
                <span class="rounded-full border border-white/10 bg-white/[0.06] px-3 py-1.5 text-xs text-white">{{ t(dataTag3) }}</span>
              </div>
              <p class="mt-4 text-sm leading-6 text-slate-200/70">
                {{ t(dataPlatformDesc) }}
              </p>
            </div>

            <div class="rounded-3xl border border-white/10 bg-white/[0.05] p-5 backdrop-blur-xl">
              <p class="text-xs uppercase tracking-[0.24em] text-slate-300/60">{{ t(contactBlockLabel) }}</p>
              <p class="mt-4 text-lg font-semibold text-white">beibei@beiyidata.cn</p>
              <p class="mt-3 text-sm leading-6 text-slate-200/70">
                {{ t(contactDesc) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from '../composables/useI18n'

const { t } = useI18n()

const companyName = {
  zh: '武汉贝易科技有限公司',
  en: 'Wuhan Beiyi Technology Co., Ltd.',
  es: 'Wuhan Beiyi Technology Co., Ltd.',
  fr: 'Wuhan Beiyi Technology Co., Ltd.',
  ja: '武漢貝易科技有限公司',
}
const title = { zh: 'Build better.', en: 'Build better.', es: 'Build better.', fr: 'Build better.', ja: 'Build better.' }
const subtitle = {
  zh: '专注构建有价值的 AI 产品与智能数据工具',
  en: 'Focused on building valuable AI products and intelligent data tools.',
  es: 'Enfocados en crear productos de IA valiosos y herramientas de datos inteligentes.',
  fr: "Nous construisons des produits IA utiles et des outils de données intelligents.",
  ja: '価値あるAIプロダクトとインテリジェントなデータツールに集中。',
}
const description = {
  zh: 'Beiyi Data 构建 AI 工具、消费应用与企业数据产品，覆盖从个人到团队的真实工作流与业务场景。',
  en: 'Beiyi Data builds AI tools, consumer apps, and enterprise data products for real-world workflows.',
  es: 'Beiyi Data crea herramientas de IA, apps de consumo y productos de datos empresariales para flujos reales.',
  fr: "Beiyi Data développe des outils IA, des apps grand public et des produits data d'entreprise pour des usages réels.",
  ja: 'Beiyi Data は、実運用に根ざしたAIツール・コンシューマーアプリ・企業向けデータ製品を構築します。',
}
const exploreButton = { zh: '查看产品', en: 'Explore Products', es: 'Explorar productos', fr: 'Explorer les produits', ja: '製品を見る' }
const contactButton = { zh: '联系我们', en: 'Contact Us', es: 'Contáctanos', fr: 'Nous contacter', ja: 'お問い合わせ' }
const consumerLabel = { zh: '消费应用', en: 'Consumer', es: 'Consumer', fr: 'Consumer', ja: 'Consumer' }
const consumerValue = {
  zh: '真实用户持续使用的 iOS 产品',
  en: 'iOS products used by real users',
  es: 'Productos iOS usados por usuarios reales',
  fr: 'Produits iOS utilisés par de vrais utilisateurs',
  ja: '実ユーザーが継続利用する iOS 製品',
}
const enterpriseLabel = { zh: '企业方案', en: 'Enterprise', es: 'Enterprise', fr: 'Enterprise', ja: 'Enterprise' }
const enterpriseValue = {
  zh: '支持私有化部署与定制交付',
  en: 'Private deployment and custom delivery',
  es: 'Despliegue privado y entrega personalizada',
  fr: 'Déploiement privé et livraison sur mesure',
  ja: 'プライベート導入とカスタム提供に対応',
}
const dataProductsLabel = { zh: '智能数据产品', en: 'Intelligent Data', es: 'Datos Inteligentes', fr: 'Data Intelligente', ja: 'インテリジェントデータ' }
const dataProductsValue = {
  zh: '贝易数据产品与治理能力',
  en: 'Beiyi data products and governance capabilities',
  es: 'Productos de datos y gobernanza de Beiyi',
  fr: 'Produits data et capacités de gouvernance Beiyi',
  ja: 'Beiyiのデータ製品とガバナンス機能',
}
const featuredLabel = { zh: '精选产品', en: 'Featured', es: 'Destacado', fr: 'Sélection', ja: '注目製品' }
const costLabel = { zh: '约 1/10 成本', en: 'About 1/10 Cost', es: 'Aprox. 1/10 costo', fr: 'Env. 1/10 du coût', ja: '約1/10コスト' }
const pageAssistantLabel = {
  zh: '智能网页助手',
  en: 'Smart page assistant',
  es: 'Asistente inteligente de página',
  fr: 'Assistant intelligent de page',
  ja: 'スマートページアシスタント',
}
const askPageLabel = {
  zh: '页面问答',
  en: 'Ask any page',
  es: 'Pregunta a la página',
  fr: 'Interroger la page',
  ja: 'ページに質問',
}
const translateLabel = {
  zh: '划词翻译',
  en: 'Highlight to translate',
  es: 'Selecciona para traducir',
  fr: 'Sélectionner pour traduire',
  ja: '選択して翻訳',
}
const summaryLabel = {
  zh: '即时总结',
  en: 'Instant summary',
  es: 'Resumen instantáneo',
  fr: 'Résumé instantané',
  ja: '即時要約',
}
const dataPlatformLabel = { zh: '智能数据产品', en: 'Intelligent Data Product', es: 'Producto de Datos Inteligentes', fr: 'Produit Data Intelligent', ja: 'インテリジェントデータ製品' }
const dataTag1 = { zh: '数据资产管理', en: 'Data Assets', es: 'Activos de Datos', fr: 'Actifs Data', ja: 'データ資産管理' }
const dataTag2 = { zh: '质量治理', en: 'Quality Governance', es: 'Gobernanza de Calidad', fr: 'Gouvernance Qualité', ja: '品質ガバナンス' }
const dataTag3 = { zh: '私有化部署', en: 'Private Deploy', es: 'Despliegue Privado', fr: 'Déploiement Privé', ja: 'プライベート導入' }
const dataPlatformDesc = {
  zh: '贝易数据产品覆盖数据资产、质量与元数据治理，支持源码授权与私有化交付。',
  en: 'Beiyi data product covers asset, quality, and metadata governance with source licensing and private delivery.',
  es: 'El producto de datos de Beiyi cubre activos, calidad y metadatos con licencia de código y entrega privada.',
  fr: 'Le produit data de Beiyi couvre actifs, qualité et métadonnées avec licence source et livraison privée.',
  ja: 'Beiyiのデータ製品は資産・品質・メタデータ統治をカバーし、ソース提供と私有化導入に対応。',
}
const contactBlockLabel = { zh: '联系', en: 'Contact', es: 'Contacto', fr: 'Contact', ja: '連絡先' }
const contactDesc = {
  zh: '产品合作、API 接入、企业方案咨询均可直接联系。',
  en: 'Contact us for product partnerships, API integration, and enterprise solutions.',
  es: 'Contáctanos para cooperación de producto, integración API y soluciones empresariales.',
  fr: "Contactez-nous pour partenariats produit, intégration API et solutions d'entreprise.",
  ja: '製品連携、API導入、企業向けソリューション相談は直接ご連絡ください。',
}

const scrollToSection = (id) => {
  const target = document.getElementById(id)
  if (!target) {
    return
  }

  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
</script>
